import useWebShareOriginal from 'react-use-web-share'

/* reexported with a TS type because original module has default export */
export const useWebShare =
  useWebShareOriginal as unknown as typeof useWebShareOriginal.default
